import { surveysStore } from "../stores";

export const useSurveysStore = () => surveysStore;
